import { render } from "./HomeSystems.vue?vue&type=template&id=bcee3eb8&scoped=true"
import script from "./HomeSystems.vue?vue&type=script&lang=js"
export * from "./HomeSystems.vue?vue&type=script&lang=js"

import "./HomeSystems.vue?vue&type=style&index=0&id=bcee3eb8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcee3eb8"]])

export default __exports__